import { ParentMenuProps } from '@toasttab/shared/src/data/HeaderNavigation/MainNavigationMenu.d'

const Products: ParentMenuProps = {
  label: 'Products',
  heapClass: 'au_topnav_pdps',
  gridCols: 'grid-cols-4 xl:grid-cols-8 min-[1440px]:pl-[156px]',
  sectionLink: {
    url: '/products',
    label: 'View All Products'
  },
  showcaseMobile: false,
  subMenus: [
    {
      label: 'Front of house',
      showLabelMobile: true,
      subMenuEntryType: 'links',
      subMenuEntries: [
        {
          label: 'Point of sale',
          icon: 'before:content-icon-hardware-flex',
          url: '/products/point-of-sale',
          heapClass: 'au_nav_pos'
        },
        {
          label: 'Handheld POS',
          icon: 'before:content-icon-toast-go',
          url: '/products/handheld-pos',
          heapClass: 'au_nav_hhpos'
        },
        {
          label: 'Toast Mobile Order & Pay®',
          icon: 'before:content-icon-software-mobile-order-pay',
          url: '/products/mobile-order-and-pay',
          heapClass: 'au_nav_mobileorder'
        },
        {
          label: 'Self-ordering kiosk',
          icon: 'before:content-icon-kiosk',
          url: '/hardware/restaurant-kiosk',
          heapClass: 'au_nav_kiosk'
        }
      ]
    },
    {
      label: 'Back of house',
      showLabelMobile: true,
      subMenuEntryType: 'links',
      subMenuEntries: [
        {
          label: 'Kitchen display system',
          icon: 'before:content-icon-flex-for-kitchen-2',
          url: '/hardware/kitchen-display-system',
          heapClass: 'au_nav_kds'
        }
      ]
    },
    {
      label: 'Digital guest engagement',
      showLabelMobile: true,
      subMenuEntryType: 'links',
      subMenuEntries: [
        {
          label: 'Email marketing',
          icon: 'before:content-icon-software-email-marketing',
          url: '/products/toast-marketing',
          heapClass: 'au_nav_email'
        },
        {
          label: 'Loyalty',
          icon: 'before:content-icon-solutions-loyalty',
          url: '/products/loyalty',
          heapClass: 'au_nav_loyalty'
        },
        {
          label: 'Gift Cards',
          icon: 'before:content-icon-gift-card',
          url: '/products/gift-card',
          heapClass: 'au_nav_giftcards'
        },
        {
          label: 'Online ordering',
          icon: 'before:content-icon-software-online-ordering',
          url: '/products/online-ordering',
          heapClass: 'au_nav_oo'
        },
        {
          label: 'Reservations and waitlist',
          icon: 'before:content-icon-solutions-tables',
          url: '/products/reservations-and-waitlist',
          heapClass: 'au_nav_tables'
        }
      ]
    },
    {
      label: 'Back office and team management',
      showLabelMobile: true,
      subMenuEntryType: 'links',
      subMenuEntries: [
        {
          label: 'Payment processing',
          icon: 'before:content-icon-payment-processing',
          url: '/products/payments',
          heapClass: 'au_nav_paymentproc'
        },
        {
          label: 'Scheduling',
          icon: 'before:content-icon-scheduling',
          url: '/products/restaurant-employee-scheduling-software',
          heapClass: 'au_nav_scheduling'
        },
        {
          label: 'Multilocation management',
          icon: 'before:content-icon-multi-location-management',
          url: '/products/multi-location-management',
          heapClass: 'au_nav_mlm'
        },
        {
          label: 'Reporting',
          icon: 'before:content-icon-reporting-analytics',
          url: '/products/reporting',
          heapClass: 'au_nav_reporting'
        }
      ]
    }
  ]
}

export default Products
